import { render, staticRenderFns } from "./ConnectionInfo.vue?vue&type=template&id=ca1c32a4&"
import script from "./ConnectionInfo.vue?vue&type=script&lang=ts&"
export * from "./ConnectionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports